import { totalTitle, formatter, monthDataConfig, bottomTitle } from '@/components/data'

export const getCountConfig = (num) => {
  return {
    number: [num || 0],
    content: '{nt}',
    textAlign: 'left',
    style: {
      fill: '#ffe',
      fontWeight: 'bold',
      fontSize: 30
    }
  }
}
const month_map = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
export const getMonthDataConfig = (month_orders) => {
  const data = Object.keys(month_orders).map(key => {
    const month_key = key.split('-')[1]
    const month = month_map[Number(month_key) - 1]
    const { order_num, order_amount } = month_orders[key]
    return [month, order_num, order_amount]
  })
  return {
    header: ['月份', '订单数', '订单金额'],
    data,
    columnWidth: [220, 240, 280],
    align: ['center'],
    rowNum: 12,
    headerBGC: '#1981f6',
    headerHeight: 45,
    oddRowBGC: 'rgba(0, 44, 81, 0.8)',
    evenRowBGC: 'rgba(10, 29, 50, 0.8)'

  }
}
export const getTotal = (total, flag) => {
  const config = []
  totalTitle.forEach(item => {
    const num = Number(total[item.name])
    const arr = num.toString().split('.')
    const fixed = arr[1] ? 2 : 0
    config.push({
      title: flag ? item.other : item.title,
      number: {
        number: formatter(num, fixed),
        total: num,
        content: '{nt}',
        textAlign: 'center',
        toFixed: fixed,
        style: {
          color: item.color,
          fontWeight: 'bold',
          fontSize: 80
        },
        formatter
      },
      width: item.width,
      unit: item.name === 'amount' ? '￥' : ''
    })
  })
  return config
}
export const getOrderConfig = (orders) => {
  const rate = document.body.clientWidth > 2000 ? 0 : 23.5
  const config = {
    header: ['时间', '订单编号', '金额', '用户'],
    data: [],
    columnWidth: [210, 225 - rate / 2, 110 - rate, 210 + rate],
    align: ['center'],
    rowNum: 15,
    headerBGC: '#1981f6',
    headerHeight: 45,
    oddRowBGC: 'rgba(0, 44, 81, 0.8)',
    evenRowBGC: 'rgba(10, 29, 50, 0.8)'
  }
  const data = []
  orders.forEach(item => {
    if (Number(item.amount)) {
      data.push([item.date, item.order_id, item.amount, item.email.replace('marketplace.amazon','**')])
    }
  })
  config.data = data
  return config
}
export const getPackageConfig = (orders) => {
  const rate = document.body.clientWidth > 2000 ? 0 : 23.5
  const config = {
    header: ['时间', '国际物流单号', '国家', '用户'],
    data: [],
    columnWidth: [210, 225 - rate / 2, 110 - rate, 210 + rate],
    align: ['center'],
    rowNum: 9,
    headerBGC: '#1981f6',
    headerHeight: 45,
    oddRowBGC: 'rgba(0, 44, 81, 0.8)',
    evenRowBGC: 'rgba(10, 29, 50, 0.8)'
  }
  const data = []
  orders.forEach(item => {
    data.push([item.date, item.shipped_number, item.country, item.mail])
  })
  config.data = data
  return config
}
export const getBottomData = (total) => {
  return bottomTitle.map(item => {
    const { name, title, color } = item
    return {
      title,
      number: {
        //number: [randomExtend(150, 400)],
        number: [total[name]],
        content: '{nt}',
        textAlign: 'right',
        style: {
          fill: color,
          fontWeight: 'bold'
        }
      },
      unit: '单'
    }
  })
}
